"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueDatepicker = require("vue-datepicker");

var _vueDatepicker2 = _interopRequireDefault(_vueDatepicker);

var _input = require("Resources/components/elements/mixins/input");

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moment = require("moment"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// for Vue 2.0

var uuidv4 = require("uuid/v4");
exports.default = {
  components: {
    "date-picker": _vueDatepicker2.default
  },

  props: ["placeholder", "name", "time", "icon", "color", "backgroundColor", "iconColor", "startDate", "endDate", "initialValue", "initialHour", "fontSize", "allowInitialValueToChangeTextData"],

  data: function data() {
    return {
      selected: "",
      // for Vue 2.0
      startTime: {
        time: ""
      },
      endtime: {
        time: ""
      },
      limit: [{
        type: "fromto",
        from: "",
        to: ""
      }],
      localeUUID: uuidv4()
    };
  },


  mixins: [_input2.default],

  computed: {
    classes: function classes() {
      var baseClasses = ["datepicker"];
      if (this.color) {
        baseClasses.push(this.inputTextColorClass);
      }

      if (this.backgroundColor) {
        baseClasses.push("has-background-" + this.backgroundColor);
      }

      return baseClasses;
    },
    setIconColor: function setIconColor() {
      return this.inputIconColorClass;
    },
    setDatePickerPlaceholderColor: function setDatePickerPlaceholderColor() {
      return this.inputTextColorClass;
    },
    option: function option() {
      return {
        type: this.time ? "min" : "day",
        week: [this.$t("common.calendar.monday_short"), this.$t("common.calendar.tuesday_short"), this.$t("common.calendar.wednesday_short"), this.$t("common.calendar.thursday_short"), this.$t("common.calendar.friday_short"), this.$t("common.calendar.saturday_short"), this.$t("common.calendar.sunday_short")],
        month: [this.$t("common.calendar.january_long"), this.$t("common.calendar.february_long"), this.$t("common.calendar.march_long"), this.$t("common.calendar.april_long"), this.$t("common.calendar.may_long"), this.$t("common.calendar.june_long"), this.$t("common.calendar.july_long"), this.$t("common.calendar.august_long"), this.$t("common.calendar.september_long"), this.$t("common.calendar.october_long"), this.$t("common.calendar.november_long"), this.$t("common.calendar.december_long")],
        format: this.time ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD",
        placeholder: this.placeholder,
        classes: this.color ? this.inputTextColorClass : "",
        placeholderColor: this.placeholderColor ? "placeholder-" + this.placeholderColor : "",
        color: {
          header: "#ccc",
          headerText: "#f00",
          checkedDay: "#290041"
        },
        buttons: {
          ok: this.$t("common.buttons.ok"),
          cancel: this.$t("common.buttons.cancel")
        }
      };
    }
  },

  watch: {
    startDate: function startDate(date) {
      this.setStartDate();
      this.setEndDate();
    },
    initialValue: function initialValue(value) {
      if (this.allowInitialValueToChangeTextData) {
        this.setInitialStateHandler();
      }
    }
  },

  methods: {
    setStartDate: function setStartDate() {
      this.limit[0].from = this.startDate ? moment(this.startDate).subtract(1, "day").endOf("day").format("YYYY-MM-DD") : "";
    },
    setEndDate: function setEndDate() {
      this.limit[0].to = this.endDate ? moment(this.endDate).add(1, "day").startOf("day").format("YYYY-MM-DD") : "";
    },
    change: function change(date) {
      this.selected = date;
      this.$emit("change", date);
    },
    setInitialStateHandler: function setInitialStateHandler() {
      var time = "";

      if (this.initialValue !== null) {
        time = this.initialValue ? this.initialValue : moment(this.startDate).set("hour", this.initialHour ? this.initialHour : "08").set("minute", "0").format("YYYY-MM-DD");
      }

      this.setStartDate();
      this.setEndDate();

      this.selected = this.startTime.time = time;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.setInitialStateHandler();
    this.$store.subscribe(function (mutation) {
      if (mutation.type === "changeLocale") {
        _this.localeUUID = uuidv4();
      }
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/DatePicker.vue
// module id = u5Zk
// module chunks = 0 1